import {
  call, debounce,
  put,
} from 'redux-saga/effects';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { requestBoundaryItems } from '~/store/boundaryItems/boundaryItems.sagas';
import { boundaryTerritoryGroupsFetchBBOXDetailsRequest } from '~/store/boundaryTerritoryDetails/boundaryTerritoryDetails.actionCreators';
import { mapToolChanged } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';

export function* dataLayersToolBoundaryTerritoryGroupSagas() {
  yield debounce(
    1000,
    mapToolChanged,
    requestBoundaryDataOnToolChange
  );
}

export function* requestBoundaryDataOnToolChange(action: ReturnType<typeof mapToolChanged>) {
  const openedTool = action.payload.newTool;
  const isDataLayers = openedTool === MapTool.DataLayers;
  const wasDataLayers = action.payload.previousTool === MapTool.DataLayers;

  if (isDataLayers || wasDataLayers) {
    yield call(requestBoundaryItems);
    yield put(boundaryTerritoryGroupsFetchBBOXDetailsRequest());
  }
}
